import styled, { keyframes } from 'styled-components';

/**
 * PageLoader Component
 * Loading fallback for lazy-loaded pages using React.lazy
 * Enhanced with MD3 motion specs
 */

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const spin = keyframes`
  0% { 
    transform: rotate(0deg); 
  }
  100% { 
    transform: rotate(360deg); 
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  /* MD3 Emphasized Easing for entrance */
  animation: ${fadeIn} 300ms cubic-bezier(0.2, 0, 0, 1);
`;

const Spinner = styled.div`
  border: 4px solid #bbdefb;
  border-top: 4px solid #215293;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: ${spin} 1s linear infinite;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-width: 3px;
  }
`;

const LoadingText = styled.p`
  color: #666;
  font-size: 0.9rem;
  font-weight: 500;
  opacity: 0;
  animation: ${fadeIn} 300ms cubic-bezier(0.2, 0, 0, 1) 150ms forwards;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export default function PageLoader() {
  return (
    <LoaderContainer>
      <Spinner />
      <LoadingText>Carregando página...</LoadingText>
    </LoaderContainer>
  );
}

